module.exports = __webpack_public_path__ + "img/01_abe_05.6f4ec946.jpg";